import { render, staticRenderFns } from "./Orders.vue?vue&type=template&id=4da1744b&scoped=true"
import script from "./Orders.vue?vue&type=script&lang=js"
export * from "./Orders.vue?vue&type=script&lang=js"
import style0 from "./Orders.vue?vue&type=style&index=0&id=4da1744b&prod&scoped=true&lang=css"
import style1 from "./Orders.vue?vue&type=style&index=1&id=4da1744b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da1744b",
  null
  
)

export default component.exports